var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamesSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 52,
    viewBox: "0 0 63 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6998 13.2943C30.0863 13.2943 25.5691 13.079 22.5573 12.2185C16.9103 10.6052 10.145 10.773 6.96051 17.5967C3.19565 25.6641 1.51648 36.4283 2.12013 41.2609C2.65757 45.5635 3.73409 47.7148 6.42226 49.3282C8.90555 50.8187 15.0274 49.866 18.2543 46.1013C21.4812 42.3366 23.2022 38.8947 24.1704 36.9584C24.7082 35.8827 25.1384 35.3449 26.8595 35.3449C28.5805 35.3449 30.8034 35.3449 31.6998 35.3449",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6996 13.2943C33.3131 13.2943 37.8303 13.079 40.8421 12.2185C46.4892 10.6052 53.2544 10.773 56.4389 17.5967C60.2038 25.6641 61.8829 36.4283 61.2793 41.2609C60.7418 45.5635 59.6653 47.7148 56.9772 49.3282C54.4939 50.8187 48.372 49.866 45.1451 46.1013C41.9182 42.3366 40.1972 38.8947 39.2291 36.9584C38.6912 35.8827 38.261 35.3449 36.54 35.3449C34.8189 35.3449 32.596 35.3449 31.6996 35.3449",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 13.2943V2",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3379 26.7397H23.0943",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7158 21.3616V32.118",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0322,
    cy: 32.5,
    r: 2.5,
    transform: "rotate(-90 46.0322 32.5)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0322,
    cy: 21.0127,
    r: 2.5,
    transform: "rotate(-90 46.0322 21.0127)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2891,
    cy: 26.7566,
    r: 2.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.7764,
    cy: 26.7561,
    r: 2.5,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesSelected);
export default __webpack_public_path__ + "static/media/gamesSelected.bf775db7.svg";
export { ForwardRef as ReactComponent };